<template>
  <div class="flex h-screen bg-gray-50 overflow-hidden">
    <!-- 左侧深色侧边栏 -->
    <Sidebar
      :is-collapsed="effectiveSidebarCollapsed"
      @toggle="toggleSidebar"
    />

    <!-- 右侧主内容区 -->
    <div class="flex-1 min-w-0 flex flex-col overflow-hidden transition-all duration-300">
      <!-- 顶部 Header -->
      <Header :breadcrumb="currentBreadcrumb" />

      <VisitedTabs />

      <!-- 主内容区域 -->
      <main class="flex-1 min-w-0 overflow-auto p-3 md:p-6">
        <router-view v-slot="{ Component, route }">
          <transition name="page" mode="out-in">
            <div
              v-if="Component"
              :key="route.fullPath"
              class="h-full"
              :class="{ 'min-w-[960px]': isNarrowViewport }"
            >
              <component :is="Component" />
            </div>
            <div v-else key="not-found" class="flex items-center justify-center h-full text-gray-400">
              <div class="text-center">
                <el-icon class="text-4xl mb-2"><Warning /></el-icon>
                <p>页面未找到: {{ route.path }}</p>
              </div>
            </div>
          </transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeUnmount, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Warning } from '@element-plus/icons-vue'
import Sidebar from '../components/Sidebar.vue'
import Header from '../components/Header.vue'
import VisitedTabs from '../components/VisitedTabs.vue'
import { addVisitedTab } from '../config/visitedTabs'

const route = useRoute()

// 侧边栏折叠状态
const isSidebarCollapsed = ref(false)
const isNarrowViewport = ref(false)

const updateViewportMode = () => {
  if (typeof window === 'undefined') return
  isNarrowViewport.value = window.innerWidth < 768
}

const effectiveSidebarCollapsed = computed(() => isNarrowViewport.value || isSidebarCollapsed.value)

const toggleSidebar = () => {
  if (isNarrowViewport.value) return
  isSidebarCollapsed.value = !isSidebarCollapsed.value
}

// 当前面包屑
const currentBreadcrumb = computed(() => {
  return (route.meta.breadcrumb as string[]) || ['首页']
})

watch(
  () => route.fullPath,
  () => addVisitedTab(route),
  { immediate: true }
)

onMounted(() => {
  updateViewportMode()
  window.addEventListener('resize', updateViewportMode)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateViewportMode)
})
</script>

